import { render, staticRenderFns } from "./edit-notes.vue?vue&type=template&id=84dd628e&"
import script from "./edit-notes.vue?vue&type=script&lang=js&"
export * from "./edit-notes.vue?vue&type=script&lang=js&"
import style0 from "./edit-notes.vue?vue&type=style&index=0&id=84dd628e&prod&lang=less&module=true&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports